// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__nPZXb","pageBody":"style_pageBody__jp63U","loader":"style_loader__95YT0","searchLayoutContainer":"style_searchLayoutContainer__AzEzN"};